module.exports = __webpack_public_path__ + "img/noAgent.f9f126a1.png";